import React from "react";

export default function ExternalLink({
  title,
  url,
}: {
  title?: string;
  url: string;
}) {
  return (
    <a href={url} target="_blank" className="text-primaryRed underline" rel="noreferrer">
      {title || url}
    </a>
  );
}
